import React from 'react';
import { Building2, Factory, Home, Shield, Users, MessageSquare, Info, ChevronDown, Construction, PencilRuler } from 'lucide-react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import ProjectGallery from './components/ProjectGallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Projects />
      <ProjectGallery />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;